export default "__VITE_PUBLIC_ASSET__aab5afc0__"